import React from 'react';
import axios from 'axios';
import $ from 'jquery'
import { HOME_DATA } from '../../url';
import PreHomePopUp from '../../component/PreHomePopUp/PreHomePopUp.jsx';
import CarouselData from '../../component/CarouselData/CarouselData.jsx';
import HomeBanner from '../../component/BannerData/HomeBannerData.jsx';
import HomeData from '../../component/HomeData/HomeData.jsx';
import ContinueWatchingThumbnail from '../../component/Thumbnail/continueWatchingThumbnail';
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../component/loader/home_loading.js";
import NoDataFound from '../../component/NoDataFound/index.js';
class Common extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingView: true,
      hasMore: true,
      updateComp: false,
      carouselData: [],
      continueWatchingData: [],
      bannerData: [],
      homeData: [],
      currentPage: 0,
      menuName: this.props.match.params.menuname,
      catId: this.props.match.params.catid,
      isHaveBanneer: null,
      reloadPageCount: 0
    }
  }
  componentDidMount() {
    let capitalizedString = this.state.menuName[0].toUpperCase() + this.state.menuName.slice(1);
    window._paq.push(['setDocumentTitle', `${capitalizedString}`]);
    window._paq.push(['trackPageView']);
    let theme = localStorage.getItem('theme')
    let location = localStorage.getItem('ecpath')
    let isAuth = localStorage.getItem('userid')
    window.addEventListener('resize', this.updateDimensions);
    if (isAuth === undefined || isAuth === null) {
      let mainval = localStorage.getItem('popup')
      if (mainval === null || mainval === undefined || mainval === '') {
        localStorage.setItem('popup', 'true')
      }
    } else {
      localStorage.setItem('popup', 'false')
    }
    let currentlocationpath = window.location.pathname
    if (theme === '1' && location === currentlocationpath) {
      let body = document.body;
      body.classList.add("blckThem");
      localStorage.setItem('themeColor', 'blckThem');
      document.body.classList.remove('topspace');
      document.body.classList.remove('heardr-rmvo');
    }
    else {
      let body = document.body;
      body.classList.remove("blckThem");
      localStorage.setItem('themeColor', 'whiteTheme');
    }
    this.getData();
    // document.body.classList.remove('darkHdr');

  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.catid !== this.props.match.params.catid) {
      window.location.reload()
    }
  }
  getData = async () => {
    let formData = new FormData();
    formData.append('page', this.state.currentPage);
    formData.append('img_type', "w");
    formData.append('category_id', this.state.catId);
    let response = await axios.post(HOME_DATA, formData, { headers: { 'token': localStorage.getItem('token') } });
    if (response.status === 200) {
      let result = response.data;
      let homeDatamain = result.home;
      let carouselData = result.Carousel
      let continueWatchingData = result.continue_watching
      let bannerData = result.banner
      this.setState({ isLoadingView: false, carouselData, continueWatchingData, bannerData, homeData: this.state.homeData.concat(homeDatamain), windowWidth: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) })
      if (this.state.reloadPageCount === 0) {
        this.setState({ reloadPageCount: 1 });

        if (this.state.windowWidth < 767) {
          setTimeout(() => {
            window.scrollTo(0, 2)
          }, 1)
        }

      }

      if (bannerData.length > 0) {
        document.body.classList.remove('darkHdr');
        document.body.classList.remove('topspace');
        document.body.classList.remove('heardr-rmvo');
      }
      else {
        document.body.classList.add('darkHdr');
        document.body.classList.remove('blckThem');
        // document.body.classList.add('topspace');
        document.body.classList.remove('heardr-rmvo');
      }
      if (carouselData.length > 0 && bannerData.length > 0) {
        this.setState({ isHaveBanneer: true })
      }
      else if (carouselData.length > 0 && bannerData.length === 0) {
        this.setState({ isHaveBanneer: true })
      }
      else {
        this.setState({ isHaveBanneer: false })
      }


      if (this.state.isHaveBanneer) {
        // document.body.classList.remove('darkHdr');
      } else {
        document.body.classList.add('darkHdr');
      }

      window.scrollTo(0, 0);

    }
    else {
      let msg = response.data.message;
      $('#snackbar .msg').html(msg);
      $('#snackbar').addClass('show').addClass('bg-danger').removeClass('bg-success');
      setTimeout(function () {
        $('#snackbar').removeClass('show');
      }, 2000);

    }
    window.scrollTo(0, 0);

  }

  updateDimensions = () => {
    this.setState({ windowWidth: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 100 });
  };



  playliveVideo = (ele) => {
    let isAuth = localStorage.getItem('userid')
    if (!isAuth) {
      this.history.push('/login')
    } else {
      localStorage.setItem('liveVideoPopup', ele);
      const liveVideoPopup = localStorage.getItem('liveVideoPopup');
    }

    (ele === 'true' ? window.scrollTo(0, 100) : window.scrollTo(0, 2))
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 500)
  }



  fetchData = async () => {
    this.setState({
      currentPage: this.state.currentPage + 1
    })
    let formData = new FormData();
    formData.append('page', this.state.currentPage);
    formData.append('img_type', "w");
    formData.append('category_id', this.state.catId);
    let response = await axios.post(HOME_DATA, formData, { headers: { 'token': localStorage.getItem('token') } });
    if (response.status === 200) {
      let result = response.data;
      let homeDatamain = result.home;
      let carouselData = result.Carousel
      let continueWatchingData = result.continue_watching
      let bannerData = result.banner
      let pagination = result.total_count
      this.setState({ isLoadingView: false, carouselData, continueWatchingData, bannerData, homeData: this.state.homeData.concat(homeDatamain) })
      if (this.state.homeData.length === pagination) {
        this.setState({
          hasMore: false
        })
      }
      //  
      if (carouselData.length > 0 && bannerData.length > 0) {
        this.setState({ isHaveBanneer: true })
      }
      else if (carouselData.length > 0 && bannerData.length === 0) {
        this.setState({ isHaveBanneer: true })
      }
      else {
        this.setState({ isHaveBanneer: false })
      }

      if (this.state.isHaveBanneer) {
        // document.body.classList.remove('darkHdr');
      } else {
        document.body.classList.add('darkHdr');
      }
    }
    else {
      let msg = response.data.message;
      $('#snackbar .msg').html(msg);
      $('#snackbar').addClass('show').addClass('bg-danger').removeClass('bg-success');
      setTimeout(function () {
        $('#snackbar').removeClass('show');
        // localStorage.clear();
        // window.location.href = "/"
      }, 2000);

    }
  }

  render() {
    const { isLoadingView, isLoading, carouselData, continueWatchingData, bannerData, homeData, menuName } = this.state;
    let param = this.props.match.params
    let popup = localStorage.getItem('popup')

    if (!isLoadingView) {

      return (
        <>
          <div
            className=" pb-3"
            style={{ paddingTop: this.state.isHaveBanneer ? "0px" : "80px" }}
          >
            {popup !== undefined &&
            popup !== null &&
            popup !== "" &&
            popup === "true" ? (
              <PreHomePopUp />
            ) : (
              ""
            )}

            {/* {
            carouselData !== undefined && carouselData !== null && carouselData.length > 0 ? <CarouselData data={carouselData} /> : ''
          } */}
            {carouselData !== undefined &&
            carouselData !== null &&
            carouselData.length > 0 ? (
              <CarouselData data={carouselData} />
            ) : (
              ""
            )}
            {bannerData !== undefined &&
            bannerData !== null &&
            bannerData.length > 0 ? (
              <HomeBanner
                data={bannerData}
                playliveVideoPopup={this.playliveVideo}
              />
            ) : (
              ""
            )}
            <div
              className="container2"
              style={{ width: this.state.windowWidth }}
            >
              {Array.isArray(continueWatchingData) &&
              continueWatchingData.length > 0 ? (
                <ContinueWatchingThumbnail data={continueWatchingData} />
              ) : null}

              {homeData && homeData.length > 0 ? (
                <InfiniteScroll
                  dataLength={homeData.length}
                  next={this.fetchData}
                  hasMore={this.state.hasMore}
                  // loader={<>
                  //   <Loader />
                  //    </>
                  // }
                >
                  <HomeData data={homeData} menuName={menuName} />
                </InfiniteScroll>
              ) : (
                ""
              )}
              {homeData &&
                homeData.length === 0 &&
                continueWatchingData &&
                continueWatchingData.length === 0 &&
                bannerData &&
                bannerData.length === 0 &&
                carouselData &&
                carouselData.length === 0 && <NoDataFound />}
            </div>
          </div>
        </>
      );
    }
    else {
      return (<Loader />)
    }
  }
}
export default Common;
